export { default as MenuAltSolidIcon } from './MenuAltSolidIcon';
